module.exports = __webpack_public_path__ + "img/Wp_2041.a3ac6de5.png";